import React from 'react';
import './TeacherLayout.css';
import { Outlet } from 'react-router-dom';
import TeacherSidebar from '../TeacherSidebar/TeacherSidebar';
import { useOpen } from '../../context/OpenContext';

const TeacherLayout = () => {
  const [open] = useOpen();
  return (
    <div className="admin-layout-container">
      <TeacherSidebar />
      <div
        style={{
          marginLeft: open ? '14rem' : '5rem',
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          height: '100vh',
        }}
      >
        <Outlet />
      </div>
    </div>
  );
};

export default TeacherLayout;
